<!-- Sem Lançamento -->
<sgt-cliente-analise-mercado-status-pretendido-badge-pill-nao-pretendido
    *ngIf="isNaoPretendido()"
    [title]="title">
</sgt-cliente-analise-mercado-status-pretendido-badge-pill-nao-pretendido>
<!-- Pretendido -->
<sgt-cliente-analise-mercado-status-pretendido-badge-pill-pretendido
    *ngIf="isPretendido()"
    [title]="title">
</sgt-cliente-analise-mercado-status-pretendido-badge-pill-pretendido>
<!-- Potencial -->
<sgt-cliente-analise-mercado-status-pretendido-badge-pill-potencial
    *ngIf="isPotencial()"
    [title]="title">
</sgt-cliente-analise-mercado-status-pretendido-badge-pill-potencial>
<!-- Realizado -->
<sgt-cliente-analise-mercado-status-pretendido-badge-pill-realizado
    *ngIf="isRealizado()"
    [title]="title">
</sgt-cliente-analise-mercado-status-pretendido-badge-pill-realizado>